/* GDP COUCHE CANON — comportement (2026-08-05)
   Additif : n ecrase aucun script existant.
   1. Ajout au panier direct depuis les vignettes de collection (faille n1 du 04/08 : ATC social 7,36 %)
   2. Annonce vocale de l ajout au panier (WCAG 4.1.3)

   MAJ 2026-08-09 (LOT 3 chantier 4 agents, T3.2 / T3.8) :
   - la grille amandes rend maintenant de vrais formulaires cote serveur ; ce fichier redevient
     ce qu il aurait toujours du etre : une amelioration progressive. buyable() refuse d injecter
     des qu un form /cart/add, un product-form, un bouton add ou un gdp-canon-quickadd existe deja
     dans la carte, et des qu une carte porte data-gdp-no-quickadd.
   - plus aucun ajout silencieux : si le produit a plus d une variante, on renvoie vers la fiche
     au lieu de choisir la premiere variante disponible a la place du client.
   - la carte upsell du tiroir (snippets/gdp-upsell-card.liquid) est pilotee ici, par delegation
     sur document : son script vivait DANS le tiroir, reecrit par innerHTML, donc il pouvait ne
     jamais s executer et le bouton retombait sur une soumission native plein ecran.
     Un seul rendu du tiroir : si gdp-cart-gift-auto est installe, c est lui qui rafraichit. */
(function(){
  'use strict';
  /* 11/10/2026 : italien uniquement ; toute autre langue garde exactement les textes d’avant. */
  var GDP_IT=String((document.documentElement&&document.documentElement.lang)||'').toLowerCase().indexOf('it')===0;
  function tr(a,b){ return GDP_IT?b:a; }
  var LABEL=tr('Ajouter au panier','Aggiungi al carrello');
  var cache={};
  function root(){ return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
  function live(){
    var el=document.getElementById('gdp-canon-live');
    if(!el){
      el=document.createElement('p'); el.id='gdp-canon-live';
      el.setAttribute('role','status'); el.setAttribute('aria-live','polite');
      el.style.cssText='position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;border:0';
      document.body.appendChild(el);
    }
    return el;
  }
  function say(m){ try{ live().textContent=m; }catch(e){} }
  function handleFrom(href){
    if(!href) return null;
    var m=href.split('?')[0].match(/\/products\/([^/]+)\/?$/);
    return m?m[1]:null;
  }
  function fetchProduct(h){
    if(cache[h]) return cache[h];
    cache[h]=fetch(root()+'products/'+h+'.js',{headers:{Accept:'application/json'}}).then(function(r){ if(!r.ok) throw new Error('http'); return r.json(); });
    return cache[h];
  }
  function refreshCartDrawer(){
    return fetch(root()+'?sections=cart-drawer',{headers:{'Cache-Control':'no-cache'},cache:'no-store'})
      .then(function(r){ return r.json(); })
      .then(function(data){
        var html=data && data['cart-drawer']; if(!html) return;
        var tmp=document.createElement('div'); tmp.innerHTML=html;
        var ns=tmp.querySelector('cart-drawer'); var cur=document.querySelector('cart-drawer');
        if(ns && cur){
          cur.classList.toggle('drawer--center-body', ns.classList.contains('drawer--center-body'));
          cur.innerHTML=ns.innerHTML;
          try{ cur.removeAttribute('hidden'); }catch(e){}
        }
      }).catch(function(){});
  }
  function refreshCart(){
    try{ document.dispatchEvent(new CustomEvent('cart:change',{bubbles:true})); }catch(e){}
    try{ document.dispatchEvent(new CustomEvent('cart-drawer:refresh',{bubbles:true})); }catch(e){}
    var d=document.querySelector('cart-drawer, .gdp-cart-drawer, #cart-drawer');
    if(!d) return;
    try{ if(typeof d.showDialog==='function') d.showDialog(); else if(typeof d.show==='function') d.show(); }catch(e){}
  }
  function add(btn){
    var h=btn.getAttribute('data-gdp-handle'); if(!h) return;
    var prev=btn.textContent;
    btn.setAttribute('data-state','loading'); btn.textContent=tr('Ajout...','Aggiunta…');
    fetchProduct(h).then(function(p){
      var variants=p.variants||[];
      if(variants.length>1){
        window.location.href=root()+'products/'+h;
        return null;
      }
      var v=variants.filter(function(x){return x.available;})[0];
      if(!v) throw new Error('indispo');
      return fetch(root()+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:v.id,quantity:1}]})})
        .then(function(r){ if(!r.ok) throw new Error('add'); return r.json(); }).then(function(){ return p; });
    }).then(function(p){
      if(!p) return;
      btn.setAttribute('data-state','done'); btn.textContent=tr('Ajoute','Aggiunto');
      say(p.title+tr(' ajoute au panier.',' aggiunto al carrello.')); refreshCart();
      window.setTimeout(function(){ btn.removeAttribute('data-state'); btn.textContent=prev||LABEL; },2200);
    }).catch(function(){
      btn.removeAttribute('data-state'); btn.textContent=tr('Reessayer','Riprova');
      say(tr('L ajout au panier n a pas abouti.','Aggiunta al carrello non riuscita.'));
      window.setTimeout(function(){ btn.textContent=prev||LABEL; },2600);
    });
  }
  function buyable(card){
    if(card.hasAttribute && card.hasAttribute('data-gdp-no-quickadd')) return true;
    return !!card.querySelector('form[action*="/cart/add"], product-form, button[name="add"], .gdp-canon-quickadd, [data-gdp-no-quickadd]');
  }
  function inject(){
    if(!/^\/(collections|search)/.test(location.pathname)) return;
    var cards=document.querySelectorAll('.gdp-ahc__item, .gdp-pc, .gdp-cg__item');
    Array.prototype.forEach.call(cards,function(card){
      if(buyable(card)) return;
      var link=card.querySelector('a[href*="/products/"]');
      var h=link&&handleFrom(link.getAttribute('href'));
      if(!h) return;
      var btn=document.createElement('button');
      btn.type='button'; btn.className='gdp-canon-quickadd';
      btn.setAttribute('data-gdp-handle',h); btn.textContent=LABEL;
      btn.setAttribute('aria-label',LABEL+' : '+(link.textContent||'').trim().slice(0,60));
      btn.addEventListener('click',function(e){ e.preventDefault(); e.stopPropagation(); add(btn); });
      var host=card.querySelector('.gdp-ahc__actions, .gdp-ahc__bottom, .gdp-pc__body, .gdp-pc__foot')||card;
      if(host.closest && host.closest('a')) host=card;
      var wrap=document.createElement('div'); wrap.className='gdp-canon-card-actions'; wrap.appendChild(btn);
      host.appendChild(wrap);
    });
  }

  /* --- Carte upsell du tiroir : delegation sur document, hors du HTML reecrit --- */
  function upsellSubmit(form){
    var btn=form.querySelector('button[type="submit"], [data-gdp-upsell-submit]');
    var icon=form.querySelector('.gdp-upsell-card__add-icon');
    var check=form.querySelector('.gdp-upsell-card__add-check');
    var spinner=form.querySelector('.gdp-upsell-card__add-spinner');
    var label=form.querySelector('.gdp-upsell-card__add-label');
    if(btn && btn.dataset && btn.dataset.loading==='1') return;
    if(btn){ if(btn.dataset) btn.dataset.loading='1'; btn.disabled=true; }
    if(icon) icon.style.display='none';
    if(spinner) spinner.style.display='inline-block';
    function reset(){
      if(btn){ if(btn.dataset) btn.dataset.loading=''; btn.disabled=false; btn.classList.remove('is-success'); }
      if(icon) icon.style.display='';
      if(check) check.style.display='none';
      if(spinner) spinner.style.display='none';
      if(label) label.textContent=tr('Ajouter','Aggiungi');
    }
    fetch(root()+'cart/add.js',{method:'POST',headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'},body:new FormData(form)})
      .then(function(r){ if(!r.ok) throw new Error('add'); return r.json(); })
      .then(function(){
        if(spinner) spinner.style.display='none';
        if(check) check.style.display='inline-block';
        if(btn) btn.classList.add('is-success');
        if(label) label.textContent=tr('Ajoute','Aggiunto');
        say(tr('Article ajoute au panier.','Articolo aggiunto al carrello.'));
        ['cart:updated','cart:refresh','cart:change','theme:cart:updated'].forEach(function(n){
          try{ document.dispatchEvent(new CustomEvent(n,{bubbles:true})); }catch(e){}
        });
        if(window.__gdpGiftAutoInstalled) return null;
        return refreshCartDrawer();
      })
      .then(function(){ window.setTimeout(reset,900); })
      .catch(function(){
        if(spinner) spinner.style.display='none';
        if(icon) icon.style.display='';
        if(label) label.textContent=tr('Reessayer','Riprova');
        say(tr('L ajout au panier n a pas abouti.','Aggiunta al carrello non riuscita.'));
        window.setTimeout(reset,2400);
      });
  }
  document.addEventListener('submit',function(e){
    var form=(e.target && e.target.closest) ? e.target.closest('[data-gdp-upsell-form]') : null;
    if(!form) return;
    // The global drawer submit owner uses GDPCart for this same form. This
    // listener shares its capture target; stopPropagation alone cannot arbitrate.
    if(window.GDPCart) return;
    e.preventDefault();
    e.stopPropagation();
    upsellSubmit(form);
  },true);

  function boot(){ try{ inject(); }catch(e){} }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
  window.setTimeout(boot,1800);
})();